export function resolveComputerHydrationCause(clauses) {
    if (clauses.quotaLoading)
        return 'quota_loading';
    if (clauses.outOfCreditsRestricted)
        return 'out_of_credits_restricted';
    if (clauses.localModeBootstrapPending)
        return 'local_mode_bootstrap_pending';
    if (clauses.catalogUnloaded)
        return 'catalog_unloaded';
    if (clauses.followupNoLastResult)
        return 'followup_no_last_result';
    if (clauses.modelConfigUnloaded)
        return 'model_config_unloaded';
    return undefined;
}
//# sourceMappingURL=computerHydration.js.map